import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ContentView } from './utils/queryParamsKeys';
import { generatePlayerPageViewUrl } from '../../utils/generatePlayerPageViewUrl';

export const RedirectToPlayerPage = () => {
	/**
	 * In Browser few links might be saved to /feature-page-view or personal-page-view
	 * so in order to avoid 404 error we are redirecting them to our player page
	 */

	const params = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const videoId = params.id;
	const playlistId = params.playlist;

	useEffect(() => {
		if (!videoId) return;

		let contentType = null;
		if (location.pathname.includes('featured-playlist-view')) {
			contentType = ContentView.FEATURED;
		} else if (location.pathname.includes('personal-playlist-view')) {
			contentType = ContentView.PERSONAL;
		} else if (location.pathname.includes('studio-playlist-view')) {
			contentType = ContentView.STUDIO;
		}

		if (contentType) {
			const url = generatePlayerPageViewUrl(videoId, contentType, playlistId);
			navigate(url, { replace: true });
		}
	}, [location.pathname, videoId, playlistId, navigate]);

	return null; // No need for an empty div
};
